import { ContractAddendum } from '../../../models/Entities/Contracts/ContractAddendum';
import { ContractReview, ContractReviewFinding } from '../../../models/Entities/Contracts/ContractReview';
import { splitNewAddendumReview } from '../../../components/Contracts/ContractReview/ContractReview.Functions';

// Página de la revisión (US3, US4, US5, US7, US9): pestañas, selección y refresco tras aplicar.

export type ReviewTab = 'findings' | 'concepts';

export const normalizeTab = (value: string | null): ReviewTab => (value === 'concepts' ? 'concepts' : 'findings');

export const addendumName = (addendums: ContractAddendum[] | undefined, id: number | null | undefined): string | undefined =>
  id === null || id === undefined ? undefined : addendums?.find(a => a.id === id)?.contractAddendumName;

// En NewAddendum el alta y el ajuste de la base van en la cabecera, no en la lista.
export const listFindings = (review: ContractReview | undefined): ContractReviewFinding[] => {
  if (!review) return [];
  return review.mode === 'NewAddendum' ? splitNewAddendumReview(review).changes : review.findings ?? [];
};

export const categoriesOf = (findings: ContractReviewFinding[]): string[] => Array.from(new Set(findings.map(f => f.category))).sort();

// La selección se poda a lo decidible y existente cada vez que cambia la revisión.
export const pruneSelection = (selected: number[], decidableIds: number[]): number[] => {
  const allowed = new Set(decidableIds);
  const next = selected.filter(id => allowed.has(id));
  return next.length === selected.length ? selected : next;
};

// Adenda a refrescar después de aplicar: la creada (NewAddendum) o la revisada.
export const addendumsToRefresh = (review: ContractReview, createdAddendumId?: number | null): number[] => {
  const ids = [createdAddendumId ?? null, review.addendumId, review.baseAddendumId].filter((id): id is number => typeof id === 'number');
  return Array.from(new Set(ids));
};
